const profile = {
    page_title: 'การตั้งค่าบัญชี',
    title: 'การตั้งค่าบัญชี',
    description: 'เปลี่ยนการตั้งค่าบัญชีและจัดการข้อมูลส่วนตัวของคุณที่นี่ เพื่อความปลอดภัยของบัญชีคุณ',
    settings: {
        title: 'การตั้งค่าโปรไฟล์',
        profile_information: 'ข้อมูลโปรไฟล์',
        avatar: 'รูปโปรไฟล์',
        name: 'ชื่อ',
        username: 'ชื่อผู้ใช้',
    },
    link_account: {
        title: 'เชื่อมโยงบัญชี',
        email_sign_in: 'เข้าสู่ระบบด้วยอีเมล',
        email: 'อีเมล',
        social_sign_in: 'เข้าสู่ระบบโซเชียล',
        link_email: 'เชื่อมโยงอีเมล',
        link_email_subtitle: 'เชื่อมโยงอีเมลของคุณเพื่อเข้าสู่ระบบหรือช่วยกู้คืนบัญชี',
        email_required: 'จำเป็นต้องกรอกอีเมล',
        invalid_email: 'ที่อยู่อีเมลไม่ถูกต้อง',
        identical_email_address: 'อีเมลที่ป้อนเหมือนกับอีเมลปัจจุบัน',
        anonymous: 'ไม่ระบุชื่อ',
    },
    password: {
        title: 'รหัสผ่านและความปลอดภัย',
        password: 'รหัสผ่าน',
        password_setting: 'ตั้งค่ารหัสผ่าน',
        new_password: 'รหัสผ่านใหม่',
        confirm_password: 'ยืนยันรหัสผ่าน',
        enter_password: 'กรอกรหัสผ่านปัจจุบัน',
        enter_password_subtitle: 'ยืนยันตัวตนของคุณเพื่อปกป้องความปลอดภัยของบัญชี กรุณากรอกรหัสผ่านปัจจุบันก่อนเปลี่ยนแปลง',
        set_password: 'ตั้งรหัสผ่าน',
        verify_via_password: 'ยืนยันด้วยรหัสผ่าน',
        show_password: 'แสดงรหัสผ่าน',
        required: 'ต้องกรอกรหัสผ่าน',
        do_not_match: 'รหัสผ่านไม่ตรงกัน กรุณาลองใหม่อีกครั้ง',
    },
    code: {
        enter_verification_code: 'กรอกรหัสยืนยัน',
        enter_verification_code_subtitle: 'รหัสยืนยันได้ถูกส่งไปที่ <strong>{{target}}</strong>',
        verify_via_code: 'ยืนยันด้วยรหัสยืนยัน',
        resend: 'ส่งรหัสยืนยันอีกครั้ง',
        resend_countdown: 'ส่งอีกครั้งใน {{countdown}} วินาที',
    },
    delete_account: {
        title: 'ลบบัญชี',
        label: 'ลบบัญชี',
        description: 'การลบบัญชีของคุณจะลบข้อมูลส่วนบุคคล ข้อมูลผู้ใช้ และการตั้งค่าทั้งหมดของคุณ การดำเนินการนี้ไม่สามารถย้อนคืนได้',
        button: 'ลบบัญชี',
        p: {
            has_issue: 'เราขออภัยที่คุณต้องการลบบัญชี กรุณาแก้ไขปัญหาดังต่อไปนี้ก่อนจึงจะสามารถลบบัญชีได้',
            after_resolved: 'เมื่อคุณได้แก้ไขปัญหาแล้ว คุณสามารถลบบัญชีของคุณได้ หากต้องการความช่วยเหลือโปรดติดต่อเรา',
            check_information: 'เราขออภัยที่คุณต้องการลบบัญชี กรุณาตรวจสอบข้อมูลต่อไปนี้ให้ถี่ถ้วนก่อนดำเนินการ',
            remove_all_data: 'การลบบัญชีจะลบข้อมูลทั้งหมดของคุณใน Logto Cloud แบบถาวร กรุณาสำรองข้อมูลสำคัญก่อนดำเนินการ',
            confirm_information: 'กรุณายืนยันว่าข้อมูลข้างต้นเป็นไปตามที่คุณคาดหวัง เมื่อคุณลบบัญชี จะไม่สามารถกู้คืนได้',
            has_admin_role: 'เนื่องจากคุณมีบทบาทผู้ดูแลในเท็นแนนต์ต่อไปนี้ จะถูกลบพร้อมกับบัญชีของคุณ:',
            has_admin_role_other: 'เนื่องจากคุณมีบทบาทผู้ดูแลในเท็นแนนต์ต่อไปนี้ ทั้งหมดจะถูกลบพร้อมกับบัญชีของคุณ:',
            quit_tenant: 'คุณกำลังจะออกจากเท็นแนนต์ต่อไปนี้:',
            quit_tenant_other: 'คุณกำลังจะออกจากเท็นแนนต์ต่อไปนี้:',
        },
        issues: {
            paid_plan: 'เท็นแนนต์ต่อไปนี้มีแผนชำระเงิน กรุณายกเลิกการสมัครสมาชิกก่อน:',
            paid_plan_other: 'เท็นแนนต์ต่อไปนี้มีแผนชำระเงิน กรุณายกเลิกการสมัครสมาชิกก่อน:',
            subscription_status: 'เท็นแนนต์ต่อไปนี้มีปัญหาสถานะการสมัครสมาชิก:',
            subscription_status_other: 'เท็นแนนต์ต่อไปนี้มีปัญหาสถานะการสมัครสมาชิก:',
            open_invoice: 'เท็นแนนต์ต่อไปนี้มีใบแจ้งหนี้ที่ยังไม่ปิด:',
            open_invoice_other: 'เท็นแนนต์ต่อไปนี้มีใบแจ้งหนี้ที่ยังไม่ปิด:',
        },
        error_occurred: 'เกิดข้อผิดพลาด',
        error_occurred_description: 'ขออภัย เกิดข้อผิดพลาดขณะลบบัญชีของคุณ:',
        request_id: 'รหัสคำขอ: {{requestId}}',
        try_again_later: 'กรุณาลองใหม่อีกครั้งในภายหลัง หากปัญหายังคงอยู่ กรุณาติดต่อทีม Logto พร้อมรหัสคำขอ',
        final_confirmation: 'ยืนยันขั้นสุดท้าย',
        about_to_start_deletion: 'คุณกำลังจะเริ่มกระบวนการลบ และการดำเนินการนี้ไม่สามารถย้อนคืนได้',
        permanently_delete: 'ลบถาวร',
    },
    set: 'ตั้งค่า',
    change: 'เปลี่ยน',
    link: 'เชื่อมโยง',
    unlink: 'ยกเลิกการเชื่อมโยง',
    not_set: 'ยังไม่ได้ตั้ง',
    change_avatar: 'เปลี่ยนรูปโปรไฟล์',
    change_name: 'เปลี่ยนชื่อ',
    change_username: 'เปลี่ยนชื่อผู้ใช้',
    set_name: 'ตั้งชื่อ',
    email_changed: 'เปลี่ยนอีเมลเรียบร้อยแล้ว',
    password_changed: 'เปลี่ยนรหัสผ่านเรียบร้อยแล้ว',
    updated: 'อัปเดต {{target}} แล้ว',
    linked: 'เชื่อมโยง {{target}} แล้ว',
    unlinked: 'ยกเลิกการเชื่อมโยง {{target}} แล้ว',
    email_exists_reminder: 'อีเมลนี้ {{email}} มีบัญชีที่เกี่ยวข้องอยู่แล้ว กรุณาเชื่อมโยงอีเมลอื่น',
    unlink_confirm_text: 'ใช่ ยกเลิกการเชื่อมโยง',
    unlink_reminder: 'หากคุณยกเลิกการเชื่อมโยง ผู้ใช้จะไม่สามารถเข้าสู่ระบบด้วยบัญชี <span></span> นี้ได้ คุณแน่ใจหรือไม่ที่จะดำเนินการต่อ?',
    fields: {
        name: 'ชื่อ',
        name_description: 'ชื่อเต็มของผู้ใช้ในรูปแบบที่สามารถแสดงผลได้ รวมทุกองค์ประกอบชื่อ (เช่น “Jane Doe”)',
        avatar: 'รูปโปรไฟล์',
        avatar_description: 'URL ของรูปโปรไฟล์ผู้ใช้',
        familyName: 'นามสกุล',
        familyName_description: 'นามสกุลของผู้ใช้ (เช่น "Doe")',
        givenName: 'ชื่อจริง',
        givenName_description: 'ชื่อจริงของผู้ใช้ (เช่น "Jane")',
        middleName: 'ชื่อกลาง',
        middleName_description: 'ชื่อกลางของผู้ใช้ (เช่น "Marie")',
        nickname: 'ชื่อเล่น',
        nickname_description: 'ชื่อเล่นหรือชื่อที่ผู้ใช้คุ้นเคย อาจต่างจากชื่อทางการ',
        preferredUsername: 'ชื่อผู้ใช้ที่ต้องการ',
        preferredUsername_description: 'รหัสย่อที่ผู้ใช้ต้องการให้เรียก',
        profile: 'โปรไฟล์',
        profile_description: 'URL ของหน้าโปรไฟล์ที่มนุษย์อ่านได้ของผู้ใช้ (เช่น โปรไฟล์โซเชียลมีเดีย)',
        website: 'เว็บไซต์',
        website_description: 'URL ของเว็บไซต์ส่วนตัวหรือบล็อกของผู้ใช้',
        gender: 'เพศ',
        gender_description: 'เพศที่ผู้ใช้ระบุเอง (เช่น "หญิง", "ชาย", "ไม่ระบุเพศ")',
        birthdate: 'วันเกิด',
        birthdate_description: 'วันเกิดของผู้ใช้ในรูปแบบที่ระบุ (เช่น "MM-dd-yyyy")',
        zoneinfo: 'เขตเวลา',
        zoneinfo_description: 'เขตเวลาของผู้ใช้ในรูปแบบ IANA (เช่น "America/New_York" หรือ "Europe/Paris")',
        locale: 'ภาษา',
        locale_description: 'ภาษาของผู้ใช้ในรูปแบบ IETF BCP 47 (เช่น "en-US" หรือ "zh-CN")',
        address: {
            formatted: 'ที่อยู่',
            streetAddress: 'ที่อยู่ถนน',
            locality: 'เมือง',
            region: 'รัฐ/จังหวัด',
            postalCode: 'รหัสไปรษณีย์',
            country: 'ประเทศ',
        },
        address_description: 'ที่อยู่เต็มของผู้ใช้ในรูปแบบที่สามารถแสดงผลได้ รวมทุกองค์ประกอบที่อยู่ (เช่น "123 Main St, Anytown, USA 12345")',
        fullname: 'ชื่อเต็ม',
        fullname_description: 'รวม familyName, givenName และ middleName ตามการตั้งค่า',
    },
};
export default Object.freeze(profile);
